/** Joins class names, skipping falsy values. */
export const cn = (...args) => args.flat().filter(Boolean).join(' ');
